module.exports = __webpack_public_path__ + "static/media/surf.c1783599.png";